// Home.js
import React from 'react';

const MyAccount = () => {
  return (
    <div className="content">
      <h1>Home</h1>
      <p>Welcome to HuntexLotto</p>
      <p>Additional content to make the page scrollable.</p>
      <p>HuntexLotto will be available soon</p>
      <p>Be on standby</p>
     
     
    </div>
  );
};

export default MyAccount;
